import OneSignal from 'react-native-onesignal';
import Constants from "expo-constants";
OneSignal.setAppId(Constants?.manifest?.extra?.oneSignalAppId);

import { Provider } from 'react-redux';
import store from './store';

import * as Linking from 'expo-linking';
import 'react-native-gesture-handler';
import React, { useCallback, useMemo, useRef } from 'react';
import { StatusBar } from 'expo-status-bar';
import { StyleSheet, Text, View, TextInput, TouchableWithoutFeedback, TouchableOpacity as RNTouchableOpacity, Button, Platform, useWindowDimensions } from 'react-native';
if (Platform.OS === 'web') {
  global._frameTimestamp = null
}
import { Picker } from '@react-native-picker/picker';
import { NavigationContainer, StackActions, useLinkTo } from '@react-navigation/native';
import { createStackNavigator } from '@react-navigation/stack';
import { createDrawerNavigator, DrawerToggleButton } from '@react-navigation/drawer';
import {
  SafeAreaView,
  SafeAreaProvider,
  SafeAreaInsetsContext,
  useSafeAreaInsets,
  initialWindowMetrics,
} from 'react-native-safe-area-context';
import { useFonts } from 'expo-font';
import stylesheet from './Style'
import MyText from './MyText';
import MyTextInput from './MyTextInput';
import MyPicker from './MyPicker';
import Header from './Header';
import Footer from './Footer';
import Collapsible from 'react-native-collapsible';
import NewRequest from './NewRequest/NewRequest';
import Home from './Home';
import Dashboard from './Dashboard';
import Documents from './Documents';
import MyModal from './MyModal';
import MyRequests from './MyRequests';
import AppLoading from 'expo-app-loading';

// import * as SplashScreen from 'expo-splash-screen';
// SplashScreen.preventAutoHideAsync();

import AsyncStorage from '@react-native-async-storage/async-storage';
import * as SecureStore from 'expo-secure-store';
import 'react-native-get-random-values';
import { v4 as uuidv4 } from 'uuid';

import {
  BottomSheetModal,
  BottomSheetModalProvider,
  BottomSheetBackdrop
} from '@gorhom/bottom-sheet';

import axios from 'axios';
import { GestureHandlerRootView, TouchableOpacity } from 'react-native-gesture-handler';
import MyNotifications from './MyNotifications';
import CustomSidebarMenu from './CustomSidebarMenu';
import Login from './Login';
import Register from './Register';
import BottomSheetModalBackdrop from './BottomSheetModalBackdrop';
import CustomBottomSheetContent from './CustomBottomSheetContent';
import LandingPage from './LandingPage';
import ManageRequests from './VGroup/ManageRequests';
import ManageUsers from './VGroup/ManageUsers';
import Splash from './Splash';
import MyProfile from './MyProfile';
import SideMenu from './SideMenu';
import WebFooter from './WebFooter';

import NetInfo from "@react-native-community/netinfo";
import * as FileSystem from 'expo-file-system';
import * as db from './database';

// import BackgroundFetch from "react-native-background-fetch";

const Stack = createStackNavigator();
const Drawer = createDrawerNavigator();
const navigationRef = React.createRef();

OneSignal.addSubscriptionObserver(event => {
  console.log("OneSignal: subscription changed event:", event);
  console.log("OneSignal: subscription changed from userId:", event.from.userId);
  console.log("OneSignal: subscription changed to userId:", event.to.userId);
  console.log("OneSignal: subscription changed from pushToken:", event.from.pushToken);
  console.log("OneSignal: subscription changed to pushToken:", event.to.pushToken);
  console.log("OneSignal: subscription changed from isPushDisabled:", event.from.isPushDisabled);
  console.log("OneSignal: subscription changed to isPushDisabled:", event.to.isPushDisabled);
  console.log("OneSignal: subscription changed from isSubscribed:", event.from.isSubscribed);
  console.log("OneSignal: subscription changed to isSubscribed:", event.to.isSubscribed);

  if(event.to.userId){
    const saveDevice = async () => {
      let uuid = uuidv4();
      let fetchUUID = await AsyncStorage.getItem('uuid')
      if (fetchUUID) {
        uuid = fetchUUID
      }
      await AsyncStorage.setItem('uuid', uuid);

      let data = {
        uuid,
        onesignal_token: event.to.userId
      };

      axios.post('/api/saveDevice.php', data)
          .then((res) => {
            console.log(res);
          })
    }
    saveDevice().catch(console.error);
  }
});

RNTouchableOpacity.defaultProps = {
  ...TouchableOpacity.defaultProps,
  activeOpacity: 0.5,
  style: {
    outline: 0
  }
};
TouchableOpacity.defaultProps.activeOpacity = 0.5;
TouchableOpacity.defaultProps.style = {
  outline: 0
};

Text.defaultProps = {};
TextInput.defaultProps = {};
Text.defaultProps.allowFontScaling = false;
TextInput.defaultProps.allowFontScaling = false;

axios.defaults.baseURL = 'https://footprint.mdataws.com';
axios.defaults.withCredentials = true;

// To open native app if it exists. Otherwise this does nothing
// TODO fix navigation from deeplink
if(Platform.OS==='web')
  window.location.replace("gr.mdata.footprint://"+window.location.pathname);

let deeplinkPrevPath = '';

export default function App() {
  const css = stylesheet();

  const [user, setUser] = React.useState(null);
  const [initial, setInitial] = React.useState('');
  const [splashFinished, setSplashFinished] = React.useState(false);
  const [firstRedirect, setFirstRedirect] = React.useState(false);

  const bottomSheetModalRef = useRef(null);
  const handlePresentModalPress = useCallback(() => {
    bottomSheetModalRef.current?.present();
  }, []);
  const handleSheetChanges = useCallback((index) => {
    console.log('handleSheetChanges', index);
  }, []);

  // const navigationRef = React.useRef();

  const [modalOpen, setModalOpen] = React.useState(false);
  const [modalHeader, setModalHeader] = React.useState('');
  const [modalBody, setModalBody] = React.useState('');
  const [modalCallback, setModalCallback] = React.useState(null);

  const [notificationsKey, setNotificationsKey] = React.useState(0);

  const [addedAxiosInterceptors, setAddedAxiosInterceptors] = React.useState(false);
  const [autoLogin, setAutoLogin] = React.useState(false);
  const [filters, setFilters] = React.useState(false);

  let [fontsLoaded] = useFonts({
      'Comfortaa-Light': require('./assets/fonts/Comfortaa-Light.ttf'),
      'Comfortaa-Regular': require('./assets/fonts/Comfortaa-Regular.ttf'),
      'Comfortaa-Medium': require('./assets/fonts/Comfortaa-Medium.ttf'),
      'Comfortaa-SemiBold': require('./assets/fonts/Comfortaa-SemiBold.ttf'),
      'Comfortaa-Bold': require('./assets/fonts/Comfortaa-Bold.ttf'),
      'futur': require('./assets/fonts/futur.otf'),
      'Futura Bold': require('./assets/fonts/futura-bold.otf'),
      'Futura Book': require('./assets/fonts/futura-book.otf'),
      'Futura Heavy': require('./assets/fonts/futura-heavy.otf'),
      'Futura Medium': require('./assets/fonts/futura-medium.otf'),
    });

  const linking = {
    prefixes: ['http://localhost:19006', 'footprint://', 'https://footprint.mdataws.com'],
    config: {
      initialRouteName: 'Landing Page',
      screens: {
        'Landing Page': '',
        'Landing Page': 'Home/:action?/:token?',
        'Register': 'Register',
        'My Requests': 'Requests/My',
        'New Request': 'Request/New',
        'Edit Request': 'Request/Edit/:id',
        'Request Info': 'Request/Info/:id',
        'Dashboard': 'Dashboard',
        'Documents': 'Documents',
        'My Notifications': 'Notifications',
        'Manage Requests': 'Requests/Manage',
        'Manage Users': 'Users/Manage',
        'User Info': 'User/:id',
        'My Profile': 'Profile',
        // 'Search': '?:id/Search',
        // 'Landing Page': '*',
      }
    },
  };

  OneSignal.setNotificationWillShowInForegroundHandler(receivedEvent => {
    console.log(receivedEvent);
    setNotificationsKey(prev => prev+1);
  });

  OneSignal.setInAppMessageClickHandler(handler => {
    //clicked on inapp
    console.log('clicked inapp');
    // OneSignal.removeTriggerForKey('showPrompt');
  })

  OneSignal.setInAppMessageLifecycleHandler(event => {
    //received inapp, for some reason this is not called
    // OneSignal.removeTriggerForKey('showPrompt');
  })

  OneSignal.setNotificationOpenedHandler(openedEvent => {
    console.log("OneSignal: notification opened:", openedEvent);
    const { action, notification } = openedEvent;
    if(notification.additionalData?.id){
      setTimeout(async() => {
        if(notification.additionalData?.dbId){
          let notifications = JSON.parse(await AsyncStorage.getItem('notifications')??'{}');
          notifications[notification.additionalData.dbId] = true;
          await AsyncStorage.setItem('notifications', JSON.stringify(notifications)); 
        }
        setNotificationsKey(prev => prev+1);
        if (navigationRef.current?.isReady()) {
          navigationRef.current.push('Request Info', { id: notification.additionalData.id });
        }
      },100);
    }
  });

  if(!addedAxiosInterceptors){
    axios.interceptors.response.use(
      (response) => {
        return response
      },
      async (error) => {
        console.log("Error: " + error);
        const originalRequest = error.config

        if (
          error.response.status === 401 &&
          (originalRequest.url === '/api/user/loginToken.php')
        ) {
          console.log("Invalid login credentials");
          setInitial('Landing Page');
          if (navigationRef.current?.isReady()) {
            navigationRef.current.push('Landing Page');
          }
          return Promise.reject(error)
        }
        if(error.response.status === 401 && originalRequest.url === '/api/user/login.php'){
          return Promise.reject(error)
        }
        if (error.response.status === 401 && !originalRequest._retry) {
          originalRequest._retry = true;
          return axios
            .post('/api/user/loginToken.php', {
              token: await AsyncStorage.getItem('token'),
              uuid: await AsyncStorage.getItem('uuid')
            })
            .then(res => {
              if (res.status === 200) {
                console.log("Logged in");
                return axios(originalRequest)
              }
            })
        }
        return Promise.reject(error)
      }
    )
    setAddedAxiosInterceptors(true);
  }

  React.useEffect(() => {
    // to prompt in-app
    const prompt = async () => {
      const deviceState = await OneSignal.getDeviceState();
      console.log(deviceState);
      if(deviceState && !deviceState.hasNotificationPermission){
        console.log('show prompt');
        OneSignal.addTrigger('showPrompt', 'true');
        setTimeout(() => {
          OneSignal.removeTriggerForKey('showPrompt');
        },100);
      }
    }
    // declare the data fetching function
    const login = async () => {
      const token = await AsyncStorage.getItem('token')??'';
      const uuid = await AsyncStorage.getItem('uuid')??'';
      const user = await AsyncStorage.getItem('user')??'';
      if(token && uuid && user){
        NetInfo.fetch().then(state => {
          if(!state.isConnected){
            let tempUser = JSON.parse(user);
            setUser(tempUser);
            return;
          }
          axios.post('/api/user/loginToken.php', {
            token,
            uuid
          }).then(async(res) => {
            setUser(res.data);
            await AsyncStorage.setItem('token', res.data.token);
            await AsyncStorage.setItem('user', JSON.stringify(res.data));
          }).catch(() =>{
            setAutoLogin(true);
          }).finally(() => {

          })
        });
      }
      else{
        setAutoLogin(true);
      }
    }
    const saveDevice = async () => {
      console.log("Save device");
      let uuid = uuidv4();
      let fetchUUID = await AsyncStorage.getItem('uuid')??'';
      if (fetchUUID) {
        uuid = fetchUUID
      }
      await AsyncStorage.setItem('uuid', uuid);

      let data = {
        uuid,
        onesignal_token: ''
      };

      axios.post('/api/saveDevice.php', data)
          .then((res) => {
            console.log(res);
          })
    }
    const filters = async () => {
      console.log("Filters");
      NetInfo.fetch().then(state => {
        if(!state.isConnected){
          setFilters(true);
          return;
        }
        axios.get('/api/getFilters.php')
        .then(async(res) => {
            await AsyncStorage.setItem('Countries', JSON.stringify(res.data.countries));
            await AsyncStorage.setItem('CollectionMeans', JSON.stringify(res.data.collectionMeans));
            await AsyncStorage.setItem('CompanyRepresentatives', JSON.stringify(res.data.companyRepresentatives));
            await AsyncStorage.setItem('RequestedPurposes', JSON.stringify(res.data.requestedPurposes));
            await AsyncStorage.setItem('Ships', JSON.stringify(res.data.ships));
            await AsyncStorage.setItem('ShipTypes', JSON.stringify(res.data.shipTypes));
            await AsyncStorage.setItem('WasteMetrics', JSON.stringify(res.data.wasteMetrics));
            await AsyncStorage.setItem('Ports', JSON.stringify(res.data.ports));
            await AsyncStorage.setItem('Locations', JSON.stringify(res.data.locations));
            await AsyncStorage.setItem('Agents', JSON.stringify(res.data.agents));
            await AsyncStorage.setItem('AgentPerPort', JSON.stringify(res.data.agentPerPort));
            setFilters(true);
        })
      });
    }
    // const configureBackgroundFetch = async () => {
    //   // BackgroundFetch event handler.
    //   const onEvent = async (taskId) => {
    //     console.log('[BackgroundFetch] task: ', taskId);
    //     // Do your background work...
        
    //     axios.get('/api/test/test.php').then(async(res) => {});

    //     // IMPORTANT:  You must signal to the OS that your task is complete.
    //     BackgroundFetch.finish(taskId);
    //   }

    //   // Timeout callback is executed when your Task has exceeded its allowed running-time.
    //   // You must stop what you're doing immediately BackgroundFetch.finish(taskId)
    //   const onTimeout = async (taskId) => {
    //     console.warn('[BackgroundFetch] TIMEOUT task: ', taskId);
    //     BackgroundFetch.finish(taskId);
    //   }

    //   // Initialize BackgroundFetch only once when component mounts.
    //   let status = await BackgroundFetch.configure({
    //     minimumFetchInterval: 15, // Fetch interval in minutes
    //     stopOnTerminate: false, // Continue background fetch after app termination
    //     startOnBoot: true, // Start background fetch on device boot
    //     enableHeadless: true, // Enable headless mode
    //     requiredNetworkType: BackgroundFetch.NETWORK_TYPE_ANY, // Network requirement
    //     requiresCharging: false, // Charging requirement
    //     requiresDeviceIdle: false, // Idle requirement
    //     requiresBatteryNotLow: false, // Battery not low requirement
    //   }, onEvent, onTimeout);

    //   console.log('[BackgroundFetch] configure status: ', status);

    //   // Optional: Start the background fetch manually
    //   // BackgroundFetch.start();
    // };
    setTimeout(() => {
      prompt().catch(console.error);
    }, 5000)
    saveDevice().catch(console.error);
    login().catch(console.error);
    filters().catch(console.error);
    // configureBackgroundFetch().catch(console.error);
    
    const unsubscribe = NetInfo.addEventListener(state => {
      console.log('Connection type', state.type);
      console.log('Is connected?', state.isConnected);
    });

    return () => {
      // Clean up and stop background fetch when component unmounts
      // BackgroundFetch.stop();
    };

  }, [])

  React.useEffect(() => {
    if(user){
      // Sync Incoming/Outgoing data
      const Sync = async() => {
        console.log("Sync");
        await db.initDatabase();
        setTimeout(() => {
          setAutoLogin(true);
        },1000);
        return;
        // NetInfo.fetch().then(async(state) => {
        //   await db.initDatabase();
        //   if(!state.isConnected){
        //     setAutoLogin(true);
        //     return;
        //   }
        //   const FormatDatetime = (dt) => {
        //     if(!dt)
        //         return '';
        //     const padLeft = (num) => {
        //         if(num < 10)
        //             return '0'+num;
        //         return num;
        //     }
        //     return dt.getUTCFullYear() + '-' + (dt.getUTCMonth()+1) + '-' + padLeft(dt.getUTCDate()) + ' ' + padLeft(dt.getUTCHours()) + ':' + padLeft(dt.getUTCMinutes()) + ':' + padLeft(dt.getUTCSeconds());
        //   }
        //   let new_updated_at = FormatDatetime(new Date());

        //   let updated_at_key = 'updated_at_v10'; // Make sure to also update it anywhere else (i.e. ManageRequests/ManageUsers/MyRequests etc.)

        //   axios.get('/api/getRequests.php', {
        //     params: {
        //         updated_at: await AsyncStorage.getItem(updated_at_key)??''
        //     }
        //   })
        //   .then(async(res) => {
        //     let result = res.data;

        //     const dir = FileSystem.documentDirectory+'Requests';
        //     const dirInfo = await FileSystem.getInfoAsync(dir);
        //     if (!dirInfo.exists) {
        //       console.log("Requests directory doesn't exist, creating...");
        //       await FileSystem.makeDirectoryAsync(dir, { intermediates: true });
        //     }
        //     const filename = 'requests.json';
        //     const requestsInfo = await FileSystem.getInfoAsync(dir+'/'+filename);
        //     if (requestsInfo.exists) {
        //       let oldRequests = JSON.parse(await FileSystem.readAsStringAsync(dir+'/'+filename));
              
        //       res.data.forEach(newReq => {
        //         let found = false;
        //         oldRequests.forEach(oldReq => {
        //           if(oldReq.id === newReq.id){
        //             found = true;
        //             oldReq = newReq;
        //           }
        //         })
        //         if(!found){
        //           oldRequests.push(newReq);
        //         }
        //       })

        //       result = oldRequests;
        //     }
        //     //need to check if requests.json exists and update the values instead of re-writing the whole file
        //     await FileSystem.writeAsStringAsync(dir+'/'+filename, JSON.stringify(result), { encoding: FileSystem.EncodingType.UTF8 });
        //     await AsyncStorage.setItem(updated_at_key, new_updated_at);
            
        //     /*res.data.forEach(req => {
        //       AsyncStorage.setItem('Request_'+req.id, JSON.stringify(req));
        //     });*/
        //     setAutoLogin(true);
        //   })
        // });
      }
      Sync().catch(console.error);
    }
  }, [user])

  const renderBackdrop = useCallback(
    (props) => <BottomSheetBackdrop {...props} pressBehavior='close' />,
    []
  );
  
  const {height, width} = useWindowDimensions();

  const Content = (nav, child) => {
    return (
      <>
        <View style={{flexDirection: 'row', flex: 1}}>
          {
            width >= 992?
            <View style={{flexGrow: 0, flexShrink: 0, flexBasis: 230}}>
              <SideMenu user={user} setUser={setUser} navigation={nav.navigation} route={nav.route} />
            </View>
            :null
          }
          <View style={{flex: 1}}>
            {child}
          </View>
        </View>
        {
          Platform.OS!=='web'?
          <Footer user={user} navigation={nav.navigation} style={{flexGrow: 0, flexShrink: 0, flexBasis: 61}}/>
          :null
        }
      </>
    )
  }

  const url = Linking.useURL();
  if(autoLogin && fontsLoaded && splashFinished && filters){
      // if(queryParams.id){
      //   setTimeout(() => {
      //     if (navigationRef.current?.isReady()) {
      //       navigationRef.current.push('Request Info', { id: queryParams.id });
      //     }
      //   },100);
      // }
  }


  const DeeplinkNavigation = () => {
    const linkTo = useLinkTo();
    let hasPath = false;

    if (url) {
      const { hostname, path, queryParams } = Linking.parse(url);

      console.log(
        `Linked to app with hostname: ${hostname}, path: ${path} and data: ${JSON.stringify(
          queryParams
        )}`
      );
      
      if(path){
        hasPath = true;
        setTimeout(() => {
          console.log(deeplinkPrevPath, path);
          if(deeplinkPrevPath != path){
            linkTo('/'+path);
            deeplinkPrevPath = path;
          }
        },100);
      }
      else{
        setTimeout(() => {
          if(user){
            let path = '';
            if(!user.isVGroup){
              path = 'Requests/My';
            }
            else{
              path = 'Requests/Manage';
            }
            if(deeplinkPrevPath != path){
              linkTo('/'+path);
              deeplinkPrevPath = path;
            }
          }
        },100);
      }
    }
    if(!hasPath && !firstRedirect){
      setFirstRedirect(true);
      setTimeout(() => {
        if(user){
          let path = '';
          if(!user.isVGroup){
            path = 'Requests/My';
          }
          else{
            path = 'Requests/Manage';
          }
          if(deeplinkPrevPath != path){
            linkTo('/'+path);
            deeplinkPrevPath = path;
          }
        }
      },100);
    }
  }
  return (
    <>
      {
        (!autoLogin || !fontsLoaded || !filters/* || !splashFinished*/)?
        null:
        <GestureHandlerRootView style={{ flex: 1 }}>
          <Provider store={store}>
            <BottomSheetModalProvider>
              <NavigationContainer ref={navigationRef} linking={linking} fallback={<Text>Loading...</Text>}>
                <DeeplinkNavigation/>
                <StatusBar style='light' />
                <BottomSheetModal
                  ref={bottomSheetModalRef}
                  index={1}
                  snapPoints={[250, user?.isVGroup?420:380]}
                  onChange={handleSheetChanges}
                  detached={false}
                  backdropComponent={renderBackdrop}
                >
                  <CustomBottomSheetContent user={user} setUser={setUser} navigation={navigationRef} bottomSheet={bottomSheetModalRef} />
                </BottomSheetModal>
                <View style={Platform.OS==='web'?{flex: 0, height: '100vh', minHeight: '100vh'}:{flex: 1}}>
                  <Stack.Navigator
                      // ref={navigationRef}
                      // initialRouteName={initial}
                      screenOptions={{
                        // drawerPosition: 'left',
                        header: (props) => <Header {...props} user={user} bottomSheet={bottomSheetModalRef} style={{position: 'absolute', top: 0, right: 0, left: 0, flexGrow: 0, flexShrink: 0, flexBasis: 74}} key={notificationsKey}/>,
                        headerShown: true,
                        animationEnabled: Platform.OS==='ios',
                        gestureEnabled: Platform.OS==='ios'
                        // cardStyle: { flex: 1 }
                        // swipeEnabled: false,
                        // drawerActiveTintColor: '#461b6f',
                        // drawerLabelStyle: {fontFamily: 'Comfortaa-Regular', fontSize: 12},
                      }}
                      // drawerContent={(props) => <CustomSidebarMenu {...props} user={user} setUser={setUser} navigation={props.navigation} />}
                    >
                      {
                        !user?
                        <>
                          <Stack.Screen name="Landing Page" options={{ drawerItemStyle: { display: 'none' } }}>
                            {props => (
                              <>
                                <LandingPage navigation={props.navigation} autoLogin={autoLogin} setUser={setUser} isInfo={false} action={props?.route?.params?.action} token={props?.route?.params?.token} />
                              </>
                            )}
                          </Stack.Screen>
                          <Stack.Screen name="Register">
                            {props => (
                              <>
                                <Register navigation={props.navigation} isInfo={false} />
                              </>
                            )}
                          </Stack.Screen>
                        </>
                        :
                        <>
                          <Stack.Screen name="Landing Page" options={{ drawerItemStyle: { display: 'none' } }}>
                            {props => (
                              <>
                                <LandingPage navigation={props.navigation} autoLogin={autoLogin} setUser={setUser} isInfo={false} action={props?.route?.params?.action} token={props?.route?.params?.token} />
                              </>
                            )}
                          </Stack.Screen>
                          <Stack.Screen name="My Requests">
                            {props => Content(props, <MyRequests user={user} navigation={props.navigation} />)}
                          </Stack.Screen>
                          <Stack.Screen name="New Request">
                            {props => Content(props, <NewRequest user={user} navigation={props.navigation} isInfo={false} />)}
                          </Stack.Screen>
                          <Stack.Screen name="Edit Request" options={{ drawerItemStyle: { display: 'none' } }}>
                            {props => Content(props, <NewRequest user={user} navigation={props.navigation} id={props.route.params.id} isInfo={false} />)}
                          </Stack.Screen>
                          <Stack.Screen name="Request Info" options={{ drawerItemStyle: { display: 'none' } }}>
                            {props => Content(props, <NewRequest user={user} navigation={props.navigation} id={props.route.params.id} isInfo={true} />)}
                          </Stack.Screen>
                          <Stack.Screen name="Dashboard">
                            {props => Content(props, <Dashboard user={user} navigation={props.navigation}/>)}
                          </Stack.Screen>
                          <Stack.Screen name="Documents">
                            {props => Content(props, <Documents/>)}
                          </Stack.Screen>
                          {
                            Platform.OS !== 'web'?
                            <Stack.Screen name="My Notifications">
                              {props => Content(props, <MyNotifications user={user} navigation={props.navigation} opened={() => setNotificationsKey(prev => prev+1)} />)}
                            </Stack.Screen>
                            :null
                          }
                          <Stack.Screen name="Manage Requests">
                            {props => Content(props, <ManageRequests user={user} navigation={props.navigation} />)}
                          </Stack.Screen>
                          <Stack.Screen name="Manage Users">
                            {props => Content(props, <ManageUsers user={user} navigation={props.navigation} />)}
                          </Stack.Screen>
                          <Stack.Screen name="User Info" options={{ drawerItemStyle: { display: 'none' } }}>
                            {props => Content(props, <Register user={user} navigation={props.navigation} id={props.route.params.id} isInfo={true} />)}
                          </Stack.Screen>
                          <Stack.Screen name="My Profile" options={{ drawerItemStyle: { display: 'none' } }}>
                            {props => Content(props, <MyProfile user={user} setUser={setUser} navigation={props.navigation} />)}
                          </Stack.Screen>
                        </>
                      }
                  </Stack.Navigator>
                </View>
                {
                  Platform.OS==='web'?
                  <WebFooter/>
                  :null
                }
                <MyModal />
              </NavigationContainer>
            </BottomSheetModalProvider>
          </Provider>
        </GestureHandlerRootView>
        }
        <Splash done={(autoLogin && fontsLoaded && filters && splashFinished)} finished={() => setSplashFinished(true)}/>
      </>
    );
}

const styles = StyleSheet.create({
  background: {
    flex: 1,
    backgroundColor: '#F6F4F9',
    padding: 20,
    overflow: 'scroll'
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1
  },
  bottomContainer: {
    flex: 1,
    padding: 24,
    justifyContent: 'center',
    backgroundColor: 'grey',
  },
  contentContainer: {
    flex: 1,
    // alignItems: 'center',
    paddingHorizontal: 30,
    paddingVertical: 10
  },
});
